var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-process-item" },
    [
      _c("can", { attrs: { i: "customize", a: _vm.processType } }, [
        _vm.processType === "ProcessTemplate"
          ? _c(
              "div",
              {
                staticClass:
                  "c-process-item__process-template-info s-text t-margin-bottom-m"
              },
              [
                _c("h2", [_vm._v("Processmall från Installatörsföretagen")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Nedan är ett förslag på process som du kan utgå från för att skapa en process för ditt företag. När du anpassat en process och publicerat den så blir den synlig för användarna på ditt företag."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Du som administratör kommer alltid åt processmallen från din anpassade process. Där får du även meddelande om uppdateringar av innehållet så du kan se om du behöver anpassa er egen process. Klicka på knappen nedan för att börja skapa er egen process."
                  )
                ]),
                _vm._v(" "),
                _vm.status === "Published" && _vm.visibility === "Public"
                  ? _c(
                      "button",
                      {
                        staticClass: "c-button c-button--primary",
                        attrs: { type: "submit" },
                        on: { click: _vm.toggleCustomizeModal }
                      },
                      [_vm._v("Använd mall för att skapa process")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "modal",
                  {
                    attrs: { show: _vm.showCustomizeModal },
                    on: { closeModal: _vm.toggleCustomizeModal }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-modal__content t-background-white t-text-align-center"
                      },
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "t-text-style-alpha t-margin-bottom-s"
                          },
                          [_vm._v("Skapa anpassad process?")]
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Du kommer nu att skapa en kopia av processmallen som du kan anpassa till ditt företag. Processmallen från Installatörsföretagen finns kvar och påverkas inte av dina ändringar."
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "c-form",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.handleSubmit($event)
                              }
                            }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                                on: { click: _vm.toggleCustomizeModal }
                              },
                              [_vm._v("Avbryt")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--primary t-margin-top-m",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.setSubmitType("customize")
                                  }
                                }
                              },
                              [_vm._v("Anpassa process")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.dataMode === "view" && _vm.id !== "0"
        ? [
            _c("div", { staticClass: "c-process-item__process-info o-grid" }, [
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:12 md:8 lg:8" }
                },
                [
                  _c("div", { staticClass: "t-text-align-left" }, [
                    _c("h1", { staticClass: "t-text-style-alpha" }, [
                      _vm._v(_vm._s(_vm.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "c-process-item__actions" },
                      [
                        _c(
                          "can",
                          { attrs: { i: "manage", a: _vm.processType } },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset",
                                on: { click: _vm.goToEditMode }
                              },
                              [
                                _c("vue-icon", {
                                  attrs: { name: "edit", size: "c-icon--17px" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "c-process-item__button" },
                                  [_vm._v("Ändra process")]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "c-button c-button--linkstyle c-button--reset",
                            attrs: { type: "button" },
                            on: { click: _vm.toggleChangeLog }
                          },
                          [
                            _c("vue-icon", { attrs: { name: "time" } }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "c-process-item__button" },
                              [_vm._v(_vm._s(_vm.buttonText))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:12 md:4 lg:4" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "t-text-align-right" },
                    [
                      _c(
                        "can",
                        { attrs: { i: "manage", a: _vm.processType } },
                        [
                          _vm.status === "Unpublished"
                            ? _c("toggle-status", {
                                attrs: {
                                  type: "Process",
                                  status: _vm.status,
                                  "process-id": _vm.processId
                                },
                                on: {
                                  publish: _vm.publishProcess,
                                  unpublish: _vm.unpublishProcess
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:12 md:12 lg:12" }
                },
                [
                  _c(
                    "collapse-transition",
                    [
                      _vm.showChangeLog
                        ? _c("change-log-data-provider", {
                            attrs: { "process-id": _vm.id },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(dataProvider) {
                                    return _c("change-log", {
                                      attrs: {
                                        "process-id": _vm.id,
                                        "process-type": _vm.processType,
                                        "change-log-entries":
                                          dataProvider.changeLogEntries,
                                        "unread-notifications":
                                          _vm.showConsentButton
                                      },
                                      on: {
                                        toggleChangeLog: _vm.toggleChangeLog,
                                        create: dataProvider.create,
                                        logReadConsent: _vm.logReadConsent
                                      }
                                    })
                                  }
                                }
                              ],
                              null,
                              false,
                              2134489324
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "o-grid__column" }, [
                _c("div", {
                  staticClass: "s-text s-text--vue t-margin-top-s",
                  domProps: { innerHTML: _vm._s(_vm.description) }
                })
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.$can("create", "NewProcess") || _vm.$can("manage", _vm.processType)
        ? [
            _vm.dataMode === "create" || _vm.dataMode === "edit"
              ? [
                  _vm.dataMode == "create"
                    ? _c(
                        "h1",
                        { staticClass: "t-text-style-alpha t-margin-bottom-s" },
                        [_vm._v("Skapa ny process")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "c-process-item__header" },
                    [
                      _vm.dataMode == "edit"
                        ? _c("h1", { staticClass: "t-text-style-alpha" }, [
                            _vm._v("Ändra process")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "can",
                        { attrs: { i: "manage", a: _vm.processType } },
                        [
                          _vm.dataMode === "edit"
                            ? _c("toggle-status", {
                                attrs: {
                                  type: "Process",
                                  status: _vm.status,
                                  "process-id": _vm.processId
                                },
                                on: {
                                  publish: _vm.publishProcess,
                                  unpublish: _vm.unpublishProcess
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "c-form c-process-item__form t-margin-top-s",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.handleSubmit($event)
                        }
                      }
                    },
                    [
                      _c("fieldset", [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "name",
                              attrs: {
                                label: "Namn på process",
                                "input-id": "name",
                                value: _vm.name
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "description",
                              attrs: {
                                label: "Beskrivning",
                                "input-id": "description",
                                value: _vm.description,
                                type: "textarea"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "t-space-between" },
                          [
                            _c(
                              "div",
                              { staticClass: "t-margin-bottom-xs" },
                              [
                                _vm.dataMode === "create"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--primary",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function($event) {
                                            return _vm.setSubmitType("create")
                                          }
                                        }
                                      },
                                      [_vm._v("Skapa process")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dataMode === "create"
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "c-button c-button--linkstyle c-button--reset",
                                        attrs: { to: "/" }
                                      },
                                      [_vm._v("Avbryt")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dataMode === "edit"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--primary",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function($event) {
                                            return _vm.setSubmitType("edit")
                                          }
                                        }
                                      },
                                      [_vm._v("Spara ändringar")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dataMode === "edit"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--linkstyle c-button--reset",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.cancelEditProcess($event)
                                          }
                                        }
                                      },
                                      [_vm._v("Avbryt")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.dataMode === "edit"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset t-margin-bottom-xs",
                                    attrs: { type: "submit" },
                                    on: { click: _vm.toggleDeleteModal }
                                  },
                                  [
                                    _c("vue-icon", {
                                      attrs: {
                                        name: "delete",
                                        size: "c-icon--17px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "c-button__title" },
                                      [_vm._v("Ta bort process")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "modal",
                              {
                                attrs: { show: _vm.showDeleteModal },
                                on: { closeModal: _vm.toggleDeleteModal }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-modal__content t-background-white t-text-align-center"
                                  },
                                  [
                                    _c(
                                      "h1",
                                      { staticClass: "t-text-style-alpha" },
                                      [
                                        _vm._v(
                                          "Bekräfta borttagning av process"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "form",
                                      {
                                        staticClass: "c-form",
                                        on: {
                                          submit: function($event) {
                                            $event.preventDefault()
                                            return _vm.handleSubmit($event)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                                            on: { click: _vm.toggleDeleteModal }
                                          },
                                          [_c("span", [_vm._v("Avbryt")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "c-button c-button--primary t-margin-top-m",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                return _vm.setSubmitType(
                                                  "delete"
                                                )
                                              }
                                            }
                                          },
                                          [_c("span", [_vm._v("Ta bort")])]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.id !== "0"
        ? _c("process-steps-data-provider", {
            staticClass: "t-margin-top-m",
            attrs: { "process-id": _vm.id },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(dataProvider) {
                    return _c("process-steps", {
                      attrs: {
                        "process-id": _vm.id,
                        "process-steps": dataProvider.processSteps,
                        "process-type": _vm.processType,
                        "show-create": dataProvider.showCreate
                      },
                      on: {
                        createProcessStep: dataProvider.createProcessStep,
                        deleteProcessStep: dataProvider.deleteProcessStep,
                        editProcessStep: dataProvider.editProcessStep,
                        setShowCreate: dataProvider.setShowCreate,
                        sortProcessStep: dataProvider.sortProcessStep,
                        publish: dataProvider.publish,
                        unpublish: dataProvider.unpublish
                      }
                    })
                  }
                }
              ],
              null,
              false,
              1409376762
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }